const axios = require('axios');
const Cookies = require('js-cookie');
const { ENDPOINT } = require('./constants');

const getBrand = (id) => axios
  .request({
    method: 'GET',
    url: `${ENDPOINT}/brands/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${
        Cookies.get('accessToken')
      }`,
    },
  })
  .then((response) => response)
  .catch((error) => error);

module.exports = {
  getBrand,
};
